import { Fragment, h } from "preact";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "preact/hooks";
import { sortBy } from "lodash";

import i18n from "../i18n.js";
import { createToastMessage, setLoading, selectPreviewMode } from "../store";
import projectsApi from "../api/projects.js";

import AppFooter from "../components/AppFooter.jsx";
import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";
import Button from "../components/Button.jsx";
import EmptyState from "../components/EmptyState.jsx";
import Icon from "../components/Icon.jsx";
import ProjectItem from "../components/projects/ProjectItem.jsx";
import List from "../components/List.jsx";

export default function ProjectsPage() {
  const isPreviewMode = useSelector(selectPreviewMode);
  const [projects, setProjects] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();

  useEffect(async () => {
    if (isPreviewMode) {
      setLoaded(true);
      return;
    }
    dispatch(setLoading(true));
    try {
      const { projects, countProjectRequests } = await projectsApi.fetchAll();

      setProjects(projects);
      setPendingCount(countProjectRequests);
    } catch (err) {
      console.error(err);
      createToastMessage(dispatch, {
        type: "error",
        message: i18n.t("errors.unexpected_error"),
      });
    }
    dispatch(setLoading(false));
    setLoaded(true);
  }, []);

  const sortedProjects = sortBy(
    projects,
    (project) => project.insertedAtOrig
  ).reverse();

  let content = null;
  if (loaded && projects.length == 0) {
    content = (
      <Fragment>
        {pendingCount ? (
          <EmptyState
            icon="projects_pending"
            title={i18n.t("pages.projects.pendingState.title", {
              count: pendingCount,
            })}
            description={i18n.t("pages.projects.pendingState.description")}
          ></EmptyState>
        ) : (
          <EmptyState
            icon="projects_add"
            title={i18n.t("pages.projects.emptyState.title")}
            description={i18n.t("pages.projects.emptyState.description")}
          >
            <Button
              iconFront="add"
              to={isPreviewMode ? "/registration" : "/projects/add"}
            >
              {i18n.t("pages.projects.createButton")}
            </Button>
          </EmptyState>
        )}
      </Fragment>
    );
  }

  if (loaded && projects.length > 0) {
    content = (
      <div class="mt-64">
        {pendingCount > 0 && (
          <p class="color-semantic-info t-body4 flex-center mb-32">
            <Icon class="mr-12">clipboard_time</Icon>
            <span>
              {i18n.t("pages.projects.pendingCount", { count: pendingCount })}
            </span>
          </p>
        )}
        <List>
          {sortedProjects.map((project) => (
            <ProjectItem linked project={project} />
          ))}
        </List>
      </div>
    );
  }

  return (
    <AppLayout
      header={
        <AppHeader
          title={i18n.t("pages.titles.projects")}
          filterBar={
            <Button
              small
              iconFront="add"
              to={isPreviewMode ? "/registration" : "/projects/add"}
            >
              {i18n.t("pages.projects.createButton")}
            </Button>
          }
        />
      }
      footer={<AppFooter />}
    >
      {content}
    </AppLayout>
  );
}
